const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

// Chapter numbering. Falls back to the plain number past the table rather than failing —
// an article with more than twelve chapters is unusual but not an error.
export const toRoman = (n: number): string => ROMAN[n - 1] ?? String(n);
